import { ClickAwayListener, MenuItem, MenuList, Paper, Popper, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import arrowRight from "../../images/arrow-right.svg"

function TableContextMenu(props){

    const {setVisible,enableChangeState,handleRowClick,target,visible,rowSelected,enableEdit,handleSetNotManaged,caseStates,handleChangeStateCases} = props;
    const [stateMenuVisible, setStateMenuVisible] = useState(false)
    const [selectedCaseState, setSelectedCaseState] = useState(null)
    const avaliableCaseStates = caseStates.filter(state=> state.stateId !==6 || !state.description.toLowerCase().includes("gestionado"))

    function handleClose(){
        setVisible(false);
    }

    function openStateMenu(){
        setStateMenuVisible(true)
    }

    function closeStateMenu(){
        setStateMenuVisible(false)
        setSelectedCaseState(null)
    }

    function handleNotManaged(){
        handleSetNotManaged()
        setVisible(false)
    }

    useEffect(()=>{
        setSelectedCaseState(null)
        setStateMenuVisible(false)
    },[target])

    return(
        <>
            <Popper open={visible} anchorEl={target} placement="left">
                <Paper elevation={4} square>
                    <ClickAwayListener onClickAway={handleClose}>
                            <MenuList>
                                <MenuItem style={{height: "3rem"}} onMouseEnter={closeStateMenu} onClick={()=>handleRowClick(rowSelected)} disabled={enableEdit}>
                                   <Typography>Editar</Typography>
                                </MenuItem>
                                {enableChangeState && 
                                    <MenuItem style={{height: "3rem"}}  selected={stateMenuVisible} id={"change-state-button"} onMouseEnter={openStateMenu}>
                                            <div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                                <Typography>Cambiar Estado</Typography>
                                                <img height={15} src={arrowRight}/>
                                            </div>   
                                    </MenuItem>
                                }
                                {enableChangeState && 
                                    <MenuItem style={{height: "3rem"}}  onMouseEnter={closeStateMenu} onClick={handleNotManaged}>
                                       <Typography>Marcar No Gestionado</Typography>
                                    </MenuItem>
                                }
                            </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
            <StateMenu visible={stateMenuVisible} selectedCaseState={selectedCaseState} setSelectedCaseState={setSelectedCaseState} handleChangeStateCases={handleChangeStateCases} setVisible={setStateMenuVisible} caseStates={avaliableCaseStates}/>
        </>
    )
}


function StateMenu(props){
    const {visible, setVisible, caseStates, handleChangeStateCases, selectedCaseState, setSelectedCaseState} = props;
    const anchorEl = document.getElementById("change-state-button")
    const [subStateMenuVisible, setSubStateMenuVisible] = useState(false)
    const [subStateAnchorEl, setSubStateAnchorEl] = useState()

    function handleClose(){
        setVisible(false)
        setSelectedCaseState(null)
        setSubStateMenuVisible(false)
        setSubStateAnchorEl(null)  
    }

    function handleOpenSubStateMenu(caseState){
        
        setSelectedCaseState(caseState)

        if(caseState.subStates.length > 0){ 
                const newAnchorEl = document.getElementById(`state-${caseState.stateId}`)
                setSubStateAnchorEl(newAnchorEl)
                setSubStateMenuVisible(true)
        } else{
            setSubStateMenuVisible(false)
            setSubStateAnchorEl(null)   
        }
    }

    async function handleChangeState(stateId){
            await handleChangeStateCases(stateId)
            setVisible(false)
            setSubStateMenuVisible(false)
            setSelectedCaseState(null)
            setSubStateAnchorEl(null)
    }

    return(
        <>
        <Popper open={visible} anchorEl={anchorEl} placement="left-start" modifiers={{preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'viewport',
                                  },
                        flip: {
                          enabled: false
                        }
                        }}>
            <Paper style={{maxHeight: "calc(100vh - 5rem)", overflowY: "auto"}} elevation={4} square>
                <ClickAwayListener onClickAway={handleClose}>
                        <MenuList>
                            {caseStates.map(caseState=>
                                    <MenuItem style={{height: "3rem"}}  onClick={()=>handleChangeState(caseState.stateId)} selected={selectedCaseState?.stateId === caseState.stateId} id={`state-${caseState.stateId}`} onMouseEnter={()=>handleOpenSubStateMenu(caseState)} key={caseState.stateId}>
                                        {   caseState.subStates.length > 0 ?
                                        
                                       <div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                            <Typography>{caseState.description}</Typography>
                                            <img height={15} src={arrowRight}/>
                                        </div>

                                        : <Typography>{caseState.description}</Typography>

                                        } 
                                    </MenuItem>
                                )
                            }
                        </MenuList>
                </ClickAwayListener>
            </Paper>
        </Popper>
        <SubStateMenu key={selectedCaseState} visible={subStateMenuVisible} setVisible={setSubStateMenuVisible} stateVisible={visible} setStateVisible={setVisible} anchorEl={subStateAnchorEl} handleChangeStateCases={handleChangeStateCases} selectedCaseState={selectedCaseState}/>
        </>
    )
}

function SubStateMenu(props){
    const {visible, setVisible, stateVisible, setStateVisible, selectedCaseState, handleChangeStateCases, anchorEl} = props;

    function closeSubStateMenu(){
            setVisible(false)
    }

    async function selectSubState(subStateId){
            await handleChangeStateCases(selectedCaseState.stateId, subStateId)
            setVisible(false)
            setStateVisible(false)
    }

    return(
        <Popper open={visible && stateVisible} anchorEl={anchorEl} placement="right-start" modifiers={
                        {preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'viewport',
                                  },
                        flip: {
                          enabled: false
                        }
                        }}>
            <Paper style={{maxHeight: "calc(100vh - 5rem)", overflowY: "auto"}}elevation={4} square>
                <ClickAwayListener onClickAway={closeSubStateMenu}>
                     <MenuList>
                        {
                            selectedCaseState?.subStates.map(subState=>
                                <MenuItem key={`subState-${subState.subStateId}`} style={{height: "3rem"}}  onClick={()=>selectSubState(subState.subStateId)}>
                                    <Typography>{subState.description}</Typography>
                                    </MenuItem>
                            )
                        }
                     </MenuList>
                </ClickAwayListener>
            </Paper>
        </Popper>
    )

}

export {TableContextMenu}